const SysOptionContractorPluginSettings: IPluginSettings = {
    name: 'Контрагенты',
    mnemocode: 'sys_option_contractor_plugin',
    permission: 'Contractor',
    columns: [{
        order: 0,
        propertyName: 'idGlobal',
        propertyType: 'string',
        displayName: 'IdGlobal',
        visibility: false,
        width: 157
    }, {
        order: 1,
        propertyName: 'name',
        propertyType: 'string',
        displayName: 'Наименование',
        visibility: false,
        width: 157
    }, {
        order: 2,
        propertyName: 'fullName',
        propertyType: 'string',
        displayName: 'Наименование полное',
        visibility: true,
        width: 257
    }
    ],
}

export default SysOptionContractorPluginSettings
